// extracted by mini-css-extract-plugin
export default {"background":"styles_background__P+kzM","container":"styles_container__vdyQi","title":"styles_title__UfqWI","description":"styles_description__xtqVI","image":"styles_image__zghwR"};